<template>
  <div class="body">
    <y-header-expert></y-header-expert>
    <div class="main-content">
      <router-view></router-view>
    </div>
    <y-footer></y-footer>
    <!--<el-backtop target=".body .main-content"></el-backtop>-->
  </div>
</template>

<script>
  import YFooter from "@/page-home/layout/components/YFooter";
  import YHeaderExpert from "@/page-home/layout/components/YHeaderExpert";
  export default {
    name: "ExpertIndex",
    components: {YHeaderExpert, YFooter}
  }
</script>

<style lang="scss" scoped>
  .body {
    width: 100%;
    height: 100%;
    min-height: 100%;
    min-width: 1200px;
    display: table;
    table-layout: fixed;
    background-color: #F2F4FA;
  }
  .main-content {
    display: table-row;
    height: 100%;
  }
</style>
